import React from 'react';
import PropTypes from 'prop-types';
import { Paper, PaperTitle, Button, PaperContent, ArticleLike } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import { ReactComponent as IconFile } from 'svg/file-alt-regular.svg';

import s from './styles.module.scss';

const Page = ({
  isFile,
  date,
  description,
  groupTitle,
  image,
  like,
  isRead,
  readDate,
  readTime,
  openPdf,
  publishedBy,
  publishedByUrl,
  title,
  onClickLike,
  documentType,
  onClickMarkAsRead,
  t,
}) => (
  <Paper>
    <PaperTitle withBorder>{t(groupTitle) || t('resources.faq')}</PaperTitle>
    {image && <img className={s.image} src={image} alt={title} />}
    <PaperContent className={s.header}>
      <div className={s.subTitle}>{title}</div>
      <div className={s.headerInfo}>
        <div className={s.infoItem}>
          {t(documentType)}
          {date && ` • ${date}`}
        </div>
        {publishedBy && (
          <div className={s.infoItem}>
            {t('publishedBy')}:
            <a href={publishedByUrl} rel="noopener noreferrer" target="_blank">
              {publishedBy}
            </a>
          </div>
        )}
      </div>
    </PaperContent>
    <PaperContent>
      {description && <div className={s.desc}>{description}</div>}
      {isFile && (
        <div className={s.viewPdf}>
          <Button onClick={openPdf} icon={<IconFile />} variant="link-secondary" size="sm">
            {t('viewPdf')}
          </Button>
        </div>
      )}
      <div>
        <Button
          className={s.markAsReadBtn}
          disabled={isRead}
          variant="secondary"
          onClick={onClickMarkAsRead}
        >
          {t('reports.markAsRead')}
        </Button>
        {isRead && (
          <span className={s.readDate}>
            {t('dateTimeFormat.readOnFormat', {
              date: readDate,
              time: readTime,
            })}
          </span>
        )}
      </div>
    </PaperContent>
    <PaperContent className={s.footer}>
      <div className={s.footerTitle}>{t('helpfulInfoQuestion')}</div>
      <ArticleLike onUpdate={onClickLike} like={like} />
    </PaperContent>
  </Paper>
);

Page.defaultProps = {
  image: null,
  date: null,
  isFile: false,
  isRead: false,
  description: null,
  like: null,
  readDate: null,
  readTime: null,
  publishedBy: null,
  publishedByUrl: null,
  groupTitle: undefined,
};

Page.propTypes = {
  date: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  groupTitle: PropTypes.string,
  description: PropTypes.string,
  publishedBy: PropTypes.string,
  publishedByUrl: PropTypes.string,
  image: PropTypes.string,
  like: PropTypes.bool,
  isRead: PropTypes.bool,
  readDate: PropTypes.string,
  readTime: PropTypes.string,
  isFile: PropTypes.bool,
  t: PropTypes.func.isRequired,
  openPdf: PropTypes.func.isRequired,
  onClickLike: PropTypes.func.isRequired,
  onClickMarkAsRead: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default withTranslation()(Page);
